import { UserRole } from "@KassaroAB/shared/types/enums/UserRole";

export const isAlgoliaSearchRole = (role: UserRole) =>
  role === UserRole.ADMIN ||
  role === UserRole.BRAND_ADMIN ||
  role === UserRole.RESELLER_ADMIN;
